import { ErrorCode } from '@afterpaytouch/portal-api'
import { useOfferDetailPBI } from '../../../state'
import { useTranslation } from '../../../utils/convergence'

const rejectedReasonCodeKey = (rejectedReasonCode: ErrorCode | undefined): string => {
  switch (rejectedReasonCode) {
    case ErrorCode.MaxActiveOrdersReached:
      return 'tooManyOrdersSubheading'
    case ErrorCode.AmountTooHigh:
      return 'accountLimitSubheading'
    case ErrorCode.OrderAmountTooHigh:
      return 'accountLimitSubheading'
    case ErrorCode.MerchantOrderAmountLimitExceeded:
      return 'merchantLimitSubheading'
    default:
      return 'genericSubheading'
  }
}

// TODO: Once REDESIGNED_PBI_REJECTED_PAGE flag is 100% rollout, remove this function since it will be unused
export const usePBIRejectedText = (): string => {
  const { t } = useTranslation()
  const offerDetailPBI = useOfferDetailPBI()

  return t(`consumerLending:paymentTypesB:${rejectedReasonCodeKey(offerDetailPBI?.rejectedReasonCode)}`, { interval: offerDetailPBI?.numberOfInstallments })
}

const getRedesignedHeadingErrorCode = (rejectedReasonCode: ErrorCode | undefined): string => {
  switch (rejectedReasonCode) {
    case ErrorCode.MaxActiveOrdersReached:
      return 'tooManyOrdersHeading'
    case ErrorCode.AmountTooHigh:
      return 'accountLimitHeading'
    case ErrorCode.OrderAmountTooHigh:
      return 'accountLimitHeading'
    case ErrorCode.MerchantOrderAmountLimitExceeded:
      return 'merchantLimitHeading'
    default:
      return 'genericHeading'
  }
}

export const usePBIRejectedRedesignedAlertBannerHeading = (): string => {
  const { t } = useTranslation()
  const offerDetailPBI = useOfferDetailPBI()

  return t(`consumerLending:paymentTypesPBIRejected.alertBanner.${getRedesignedHeadingErrorCode(offerDetailPBI?.rejectedReasonCode)}`)
}
